import type { PiletApi } from '@chess/platform-web';
import { CONSTRAINTS_API, ConstraintStore } from '@chess/api-constraints';

// The constraint registry as the `constraints` API: owners (the puzzles
// plugin first) register constraints on a scope, a review board tab or a
// played game, and the cards that honour them follow the combined value of
// their own type. The registry holds no other state. See
// docs/architecture/review-constraints.md.
export function setup(app: PiletApi) {
  app.registerApi(CONSTRAINTS_API, new ConstraintStore());
}
